import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Reveal, Label } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { CTASection } from "../components/CTASection";

const VALEURS = [
  { n: "01", title: "Savoir-faire", text: "Résine, béton ciré, moquette de pierre : des matériaux techniques que nous maîtrisons dans leurs moindres détails, de la préparation à la finition." },
  { n: "02", title: "Préparation des supports", text: "Nous consacrons à la préparation le temps qu'elle mérite : diagnostic, réparation, ponçage, primaire. C'est elle qui garantit la durabilité de chaque revêtement." },
  { n: "03", title: "Conseil & accompagnement", text: "Un projet de sol soulève beaucoup de questions. Nous y répondons avec clarté et vous orientons vers la solution réellement adaptée à votre usage." },
  { n: "04", title: "Qualité de finition", text: "Angles nets, raccords propres, chantier protégé et rendu propre : le soin du détail est notre signature." },
  { n: "05", title: "Adaptation au projet", text: "Maison, commerce, bureau, usine : chaque cahier des charges est différent. Le système recommandé découle de vos contraintes, jamais l'inverse." },
  { n: "06", title: "Intervention nationale", text: "Basés dans la région toulousaine, nous intervenons partout en France, pour des projets résidentiels comme professionnels." },
];

const APropos = () => (
  <>
    <Seo
      title="Resineko, spécialiste des revêtements de sols | À propos"
      description="Découvrez Resineko : savoir-faire, préparation rigoureuse des supports, accompagnement personnalisé et finitions soignées. Intervention partout en France."
      path="/a-propos"
    />
    <PageHero
      kicker="À propos"
      title="Resineko, spécialiste des revêtements de sols"
      subtitle="Une entreprise à taille humaine, animée par le goût du travail bien fait et des matériaux d'exception."
      image="/images/deco-garage-marbre-bleu.jpg"
    />

    <section className="noise-bg bg-[#0A0A0A] py-20 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 md:grid-cols-12 md:px-10">
        <div className="md:col-span-5">
          <Reveal><Label>Notre approche</Label></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-[1.05] text-[#F4F4F0] md:text-5xl">
              Le beau et le durable ne s'opposent jamais
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <Reveal delay={0.15}>
            <div className="space-y-6 text-sm leading-relaxed text-[#8C8C8C] md:text-base">
              <p>
                Resineko est née d'une conviction : un sol réussi transforme un lieu entier. Basée dans la région toulousaine, notre entreprise accompagne particuliers, professionnels et industriels dans leurs projets de revêtements — résine décorative, industrielle ou pailletée, béton ciré, moquette de pierre et peinture en bâtiment.
              </p>
              <p>
                Notre exigence commence là où l'on ne regarde pas : sous le revêtement. Diagnostic du support, contrôle de l'humidité, préparation mécanique, primaires adaptés — chaque étape invisible conditionne la beauté et la longévité du résultat final.
              </p>
              <p>
                Parce qu'aucun projet ne ressemble à un autre, nous prenons le temps d'écouter, de conseiller et de proposer le système juste. De la première prise de contact à la réception du chantier, vous échangez avec des interlocuteurs qui connaissent votre projet.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>

    <Marquee items={["Savoir-faire", "Précision", "Conseil", "Finitions soignées", "Partout en France"]} />

    <section className="bg-[#F4F4F0] py-20 text-[#0A0A0A] md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal><Label light>Ce qui nous définit</Label></Reveal>
        <div className="mt-12 grid gap-px overflow-hidden border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-3">
          {VALEURS.map((v, i) => (
            <Reveal key={v.n} delay={i * 0.05}>
              <div className="h-full bg-[#F4F4F0] p-8 transition-colors duration-500 hover:bg-[#ecece6] md:p-10" data-testid={`valeur-${v.n}`}>
                <span className="font-serif text-lg italic text-[#047857]">{v.n}</span>
                <h3 className="mt-4 font-serif text-2xl font-normal">{v.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#0A0A0A]/60">{v.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <CTASection title="Envie d'un sol à la hauteur de votre projet ?" />
  </>
);

export default APropos;
